module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAAIVBMVEV9mlt9mlv///+dsoOJpGrg59fL173v8uv3+fWsvpW5yKb6MbK8AAAAAXRSTlOArV5bRgAAAS5JREFUeAHt1L9OwzAQBvD2DWolIGW9KNR0ywKzkcjQMaFDVsgTMNG1Qh26FQkxBwZeE/9po8SOPw8RE3i9n9zzd5fO5gyexQzXGfsH08BmU2FAlE4AlyIAPg8YxDt6gOCCiLcIvBFRhkD0LAVssggBdhsC8WMA6DZw1MUZfAVm8ZFhcE90REC99xWAZCfByg+iUtZ56wXXKgxq/E3qU4GVU2fLMFgJG+QDkAkn6pemB5a5M4uEqO4Ab5kD5DbSXvRnYYE7/ctHP9CbRLzxAvZunl/3QDzMYW02ep+fQVRaQUV6At13kZRkJxl/n8agQCIvdKO+6cBaLcTILEwjKStUfQyYRlJz09XoNFUjS10/CLwwW4EXpraTtEDlRD0ETwwCflqeX/kj/ZtgjsHiB/lZsvkHQVMgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trunk-cms_icon.png
// module id = 103
// module chunks = 8